module.exports = __webpack_public_path__ + "img/cncj-bab-3-modif.64c79ccf.jpg";